import { createSlice } from "@reduxjs/toolkit";

import { mainPageInitialState } from "./main-page.initialState";
import { getContent } from "./main-page.thunks";

const mainPageSlice = createSlice({
  name: "mainPage",
  initialState: mainPageInitialState,

  extraReducers: builder => {
    builder
      .addCase(getContent.pending, state => {
        state.isLoading = true;
      })
      .addCase(getContent.rejected, (state, action) => {
        state.isError = action.payload;
        state.isLoading = false;
      })
      .addCase(getContent.fulfilled, (state, action) => {
        state.mainPageData = action.payload;
        state.isDataLoaded = true;
        state.isLoading = false;
      });
  },
});

export const MainPageActions = {
  ...mainPageSlice.actions,
  getContent,
};

export default mainPageSlice.reducer;
